<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 20 20"
    aria-hidden="true"
  >
    <path
      d="M24.4,11.022a1.022,1.022,0,0,1-1.022,1.022H7.022A1.022,1.022,0,0,1,6,11.022H6A1.022,1.022,0,0,1,7.022,10H23.374A1.022,1.022,0,0,1,24.4,11.022Z"
      transform="translate(-5.199 -7.154)"
      fill="currentColor"
      class="origin-center transition-all"
      :class="{ 'translate-x-[-2px] translate-y-[1px] -rotate-45': open }"
    />
    <path
      d="M24.4,23.022a1.022,1.022,0,0,1-1.022,1.022H7.022A1.022,1.022,0,0,1,6,23.022H6A1.022,1.022,0,0,1,7.022,22H23.374A1.022,1.022,0,0,1,24.4,23.022Z"
      transform="translate(-5.199 -13.022)"
      fill="currentColor"
      class="transition-opacity"
      :class="{ 'opacity-0': open }"
    />
    <path
      d="M24.4,35.022a1.022,1.022,0,0,1-1.022,1.022H7.022A1.022,1.022,0,0,1,6,35.022H6A1.022,1.022,0,0,1,7.022,34H23.374A1.022,1.022,0,0,1,24.4,35.022Z"
      transform="translate(-5.199 -18.891)"
      fill="currentColor"
      class="origin-center transition-all"
      :class="{ 'translate-x-[16px] translate-y-[-23px] rotate-45': open }"
    />
  </svg>
</template>

<script setup>
defineProps({
  open: { type: Boolean, required: false },
})
</script>
